import { WALLETS } from "@/app/constants/wallet";
import { useToast } from "@/app/hooks/toast/useToast";
import { client } from "@/app/utils/wallet/walletUtils";
import axios from "axios";
import React, { useCallback, useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useConnectModal } from "thirdweb/react";

type Props = {
  walletId: string | null | undefined;
  theme?: string;
  label: string;
  className?: string;
};

type VerifyTokenResponse = {
  success: boolean;
  score: number | null;
};

export const ThirdWeb = ({ walletId, label = "Sign In", className }: Props) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [isLoading, setLoading] = useState(false);
  const { connect } = useConnectModal();
  const { showToast } = useToast();

  const openConnectModal = useCallback(async () => {
    connect({
      client,
      wallets: WALLETS,
    });
  }, [connect]);

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      console.log("executeRecaptcha not yet available");
      return;
    }

    setLoading(true);

    const token = await executeRecaptcha("auth");

    const { data } = await axios.post<VerifyTokenResponse>(
      "/api/verify-token",
      { token }
    );

    if (data.success) {
      openConnectModal();
    } else {
      showToast("Oops, please try again in a moment.", "error");
    }

    setLoading(false);
  }, [executeRecaptcha, openConnectModal, showToast]);

  if (walletId) {
    return null;
  }

  if (!executeRecaptcha) {
    return (
      <span className="dots-container">
        <span className="dot !text-black"></span>
        <span className="dot !text-black"></span>
        <span className="dot !text-black"></span>
      </span>
    );
  }

  return (
    <button
      className={`font-unbounded text-sm ${className ? className : ""}`}
      onClick={handleReCaptchaVerify}
      disabled={isLoading}
    >
      {isLoading ? (
        <span className="dots-container">
          <span className="dot !text-black"></span>
          <span className="dot !text-black"></span>
          <span className="dot !text-black"></span>
        </span>
      ) : (
        label
      )}
    </button>
  );
};
